import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import * as moment from "moment";
import { UrlConstants } from "src/app/models/urlConstants";

@Component({
  selector: "app-select-statement-date",
  templateUrl: "./select-statement-date.component.html",
  styleUrls: ["./select-statement-date.component.scss"],
})
export class SelectStatementDateComponent implements OnInit {
  today = new Date();
  dateFrom: Date = new Date(this.today.setMonth(this.today.getMonth() - 13));
  dateTo: Date = new Date();
  statement;
  loadingStatement = false;

  constructor(
    private http: HttpClient
  ) { }

  ngOnInit(): void { }

  viewStatement() {
    this.loadingStatement = true;
    this.fetchClientStatement().subscribe((res) => {
      this.statement = res[0];
      this.loadingStatement = false;
    });
  }

  fetchClientStatement() {
    let from = moment(this.dateFrom).format("MM-DD-YYYY");
    let to = moment(this.dateTo).format("MM-DD-YYYY");
    // 01-03-2020
    return this.http.get<any[]>(
      `${UrlConstants.backofficeUrl}/api/Client/getClientStatement?fromDate=${from}&toDate=${to}&lang=1&relationCode=1001-1`
    );
  }
}
